/** @type {UICore.UILib} */
export const defaultUILib = {
  async alert({
    content
  }) {
    window.alert(content);
  },
  async confirm({
    content
  }) {
    return window.confirm(content);
  },
  message({
    content,
    duration,
    type
  }) {
    const el = document.createElement('div');
    el.className = `uc-message uc-message-entering uc-message-${type}`;
    el.textContent = content;
    el.onanimationend = () => {
      el.classList.remove('uc-message-entering');
    };
    const close = () => {
      el.classList.remove('uc-message-entering');
      el.classList.add('uc-message-leaving');
      el.onanimationend = () => {
        var _el$parentElement;
        el.classList.remove('uc-message-entering');
        (_el$parentElement = el.parentElement) === null || _el$parentElement === void 0 || _el$parentElement.removeChild(el);
      };
    };
    if (duration > 0) setTimeout(close, duration);
    el.addEventListener('click', close, false);
    document.body.appendChild(el);
  },
  async prompt({
    defaultValue,
    message
  }) {
    return window.prompt(message, defaultValue || '');
  }
};
//# sourceMappingURL=uiLib.js.map
